import YProForm from './src/main'

YProForm.install = function(Vue) {
  Vue.component(YProForm.name, YProForm)
}

export default YProForm
